
declare const __API_BASE__: string;
export const API_BASE = __API_BASE__;
export const APP_VERSION = (import.meta as any).env?.VITE_APP_VERSION || '0.0.0';
export const BUILD_TIME = (import.meta as any).env?.VITE_BUILD_TIME || '-';

export const MODEL_NAME = "gemini-3-pro-preview";
export const ARTICLE_SPLIT_TOKEN = "<!-- ===ARTICLE_SPLIT=== -->";
